import type { ActivityAdapter, ActivityRow } from '../../core';
import { OpenedRow } from './OpenedRow';
import { renderDocumentRow } from './renderDocumentRow';
import { toDocumentRows } from './toDocumentRows';
import { toOpenedRows } from './toOpenedRows';

export const documentChangesAdapter: ActivityAdapter = {
  toRows: toDocumentRows,
  renderRow: renderDocumentRow,
};

const renderOpenedRow = (row: ActivityRow) =>
  row.kind === 'opened' ? (
    <OpenedRow openedAt={row.openedAt} closedAt={row.closedAt} />
  ) : null;

export const documentOpenedAdapter: ActivityAdapter = {
  toRows: toOpenedRows,
  renderRow: renderOpenedRow,
};
